<template>
  <v-dialog v-model="open" max-width="420">
    <v-card>
      <v-card-title class="dialog-header-v d-flex align-center justify-center  py-8" :style="{ backgroundColor: backgroundColor }">
        <v-icon color="white" class="mr-2" size="x-large">
          {{ icon }}
        </v-icon>
      </v-card-title>

      <v-card-text>

        <div class="d-flex justify-center mt-4">
            {{ message }}
        </div>
      </v-card-text>

      <v-card-actions class="d-flex justify-center">
        <v-btn color="primary" variant="outlined"  class="mb-2" @click="close">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SystemDialog',

  computed: {
    ...mapState('systemDialog', [
        'open',
        'title',
        'message',
        'type'
    ]),

    icon() {
        return {
            success: 'mdi-checkbox-marked-circle-outline',
            error: 'mdi-alert-circle',
            warning: 'mdi-alert',
            info: 'mdi-information'
        }[this.type]
    },

    iconColor() {
        return {
            success: 'green',
            error: 'red',
            warning: 'orange',
            info: 'blue'
        }[this.type]
    },

    backgroundColor() {
        return {
            success: '#748873',
            error: '#D73535',
            warning: '#FB8C00',
            info: '#2196F3'
        }[this.type]
    }
  },

  methods: {
    ...mapActions('systemDialog', ['close'])
  }
}
</script>

<style>
.dialog-header-v {
  background-color: #748873;
  height: 110px;

  clip-path: polygon(
    0 0,
    100% 0,
    100% 75%,
    50% 100%,
    0 75%
  );
}

</style>